var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-card-content" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-checkbox", {
                attrs: {
                  value: _vm.overwriteExistingViews,
                  label: _vm.$ct("remove-existing-views"),
                },
                on: {
                  input: function ($event) {
                    return _vm.$emit("update:overwriteExistingViews", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-checkbox", {
                attrs: { label: _vm.$ct("toggle-views") },
                on: {
                  input: function ($event) {
                    return _vm.toggleAllViews()
                  },
                },
                model: {
                  value: _vm.toggleViews,
                  callback: function ($$v) {
                    _vm.toggleViews = $$v
                  },
                  expression: "toggleViews",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("w-divider"),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            _vm._l(_vm.browses, function (browse) {
              return _c(
                "div",
                { key: browse.ID, staticClass: "browse" },
                [
                  _c("w-checkbox", {
                    attrs: {
                      value: _vm.isBrowseSelected(browse),
                      label: browse.Name.getTranslation(_vm.$i18n.locale),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.toggleBrowse(browse, $event)
                      },
                    },
                  }),
                  _vm._l(browse.Views, function (view) {
                    return _c(
                      "div",
                      { key: view.ID, staticClass: "view" },
                      [
                        _c("w-checkbox", {
                          attrs: {
                            label: view.Name,
                            value: _vm.isViewSelected(view),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.toggleView(view, $event)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }